import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import { CurrencyFormatter } from "@/i18n/currency";

const PerMonthPriceInfo = ({ pricePerDay, initialPricePerDay, t }) => {
  return (
    <S.Wrap>
      {initialPricePerDay?.amount > pricePerDay.amount && (
        <>
          <strike>{CurrencyFormatter.format(initialPricePerDay)}</strike>
        </>
      )}
      <strong>{CurrencyFormatter.format(pricePerDay)}</strong>
      <span>{t("premium:price_per_day")}</span>
    </S.Wrap>
  );
};
PerMonthPriceInfo.propTypes = {
  period: PT.number,
  pricePerMonth: PT.object,
  initialPricePerMonth: PT.object,
  pricePerDay: PT.object,
  initialPricePerDay: PT.object,

  t: PT.func.isRequired,
};

export default PerMonthPriceInfo;
